import api from "../../../api/axios";

// Feature-local wrapper for the Communication list used by the
// stale-data tolerance screen (Phase 16).
//
// Endpoint (per backend/app/apps/clients/views.py CommunicationListCreateView):
//   GET /api/crm/clients/{client_id}/communications/
//        — accessible-client gate (owner OR share).
//        — returns CommunicationSerializer payloads
//          ({id, client, property, deal, type, direction, content,
//            created_by, created_at}), ordered by -created_at server-side
//          (apps/clients/models.py Communication.Meta.ordering).
//
// Phase 16 reads this list explicitly on initial load and on manual
// refresh. There is NO automatic refetch, NO cache, NO invalidation,
// NO sync layer — by design. Per the brief, freshness is screen-local,
// passive, and manually resolved.
//
// Stateless request wrapper. No cache. No retry. No invalidation.

export const fetchCommunications = (clientId) =>
  api.get(`/crm/clients/${clientId}/communications/`).then((res) => res.data);
